import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';

import "../../css/documents/Main.css";

import MultiSelect from '../common/MultiSelect';
import {
  typeOptions, disciplineOptions,
  statusOptions, equipmentTagOptions,
  releasePurposeOptions, organizationCodeOptions,
  unitCodeOptions, elementOptions,
  documentClassOptions, oTIntegrationSystemOptions,

} from '../utils/selectOptions';

const Main = () => {
  const navigate = useNavigate();
  const [type, setType] = useState(null);
  const [discipline, setDiscipline] = useState(null);
  const [status, setStatus] = useState(null);
  const [equipmentTag, setEquipmentTag] = useState(null);
  const [releasePurpose, setReleasePurpose] = useState(null);
  const [organizationCode, setOrganizationCode] = useState(null);
  const [unitCode, setUnitCode] = useState(null);
  const [element, setElement] = useState(null);
  const [documentClass, setDocumentClass] = useState(null);
  const [oTIntegrationSystem, setOTIntegrationSystem] = useState(null);



  const [filters, setFilters] = useState({
    documentNumber: "",
    title: "",
    type: "",
    discipline: "",
    status: "",
    revision: "",
    dateRange: "",
  });

  const [globalSearch, setGlobalSearch] = useState("");
  const [results, setResults] = useState([
    {
      file: "PDF",
      documentNumber: "PM210012-LTG531-ER2-00004",
      revision: "04",
      title: "PV PLANT - GENERAL CALCULATION REPORT AND",
      type: "Report",
      releasePurpose: "IFR - Issued for Review",
      status: "Code 4",
      discipline: "ELE - Electrical",
      revisionDate: "02/12/2023",
      dateModified: "11/12/2023",
      reviewSource: "WF-017411",
      organization: "LTG",
    },
  ]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleGlobalSearch = (e) => {
    setGlobalSearch(e.target.value);
  };

  const handleSearch = () => {
    // Add search logic here (e.g., fetch filtered data from API)
    console.log("Filters1:", filters);
  };

  // Filtered results based on global search
  const filteredResults = results.filter((result) =>
    Object.values(result).some((value) =>
      value.toString().toLowerCase().includes(globalSearch.toLowerCase())
    )
  );

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleClick = () => {
    alert("Clickable text clicked!");
  };

  const [rows, setRows] = useState(
    Array.from({ length: 1 }, (_, rowIndex) =>
      Array.from({ length: 21 }, (_, colIndex) => ({
        content: `Row ${rowIndex + 1}, Col ${colIndex + 1}`,
        isSelected: false, // Checkbox state
      }))
    )
  );

  // Handle "Select All" checkbox
  const handleSelectAll = (isChecked) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.map((cell, colIndex) =>
          colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
        )
      )
    );
  };

  // Handle individual row checkbox
  const handleRowCheckboxChange = (rowIndex, isChecked) => {
    setRows((prevRows) =>
      prevRows.map((row, rIndex) =>
        rIndex === rowIndex
          ? row.map((cell, colIndex) =>
            colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
          )
          : row
      )
    );
  };

  // Check if all rows are selected
  const isAllSelected = rows.every((row) => row[0].isSelected);

  return (
    <div className="documents-main">
      <div className="document-register">
        <div className="document-register-header">
          Search - Document Register
        </div>
        <div className="document-register-subheader">Document Activity</div>
        <div className="document-register-description">
          Tell us what you think
        </div>
      </div>
      <div className="filters">
        <div className="top">
          <div className="filters-header">
            <div className="global-search-bar">
              <div className="search-bar-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#000000" /* Icon color */
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="search-icon"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="16" y1="16" x2="22" y2="22"></line>
                </svg>
                <input
                  type="text"
                  placeholder="Search across all document fields including Document Number"
                  value={globalSearch}
                  onChange={handleGlobalSearch}
                />
              </div>
              <button className="search" onClick={handleSearch}>
                Search
              </button>
              <button className="save-search" onClick={handleSearch}>
                Save Search As...
              </button>
              <button className="search" onClick={handleSearch}>
                Clear all filters
              </button>
              {/* <a href="#">Clear all filters</a> */}
            </div>
            <div className="search-options">
              <label>
                <input type="checkbox" id="fileContent" /> File Content
              </label>
              <label>
                <input type="checkbox" id="showDocumentHistory" /> Show Document
                History
              </label>
            </div>
          </div>

          <div className="input-fields-container">
            <div className="row">
              <div className="input-field">
                <label htmlFor="field1">Document No</label>
                <input
                  type="text"
                  id="field1"
                  defaultValue="PM210012-LTG531-ER2-0004"
                />
              </div>
              <div className="input-field">
                <label htmlFor="field2">Title</label>
                <input type="text" id="field2" />
              </div>

              <div className="input-field">
                <label htmlFor="type-select">Type</label>
                <MultiSelect
                  options={typeOptions}
                  value={type}
                  onChange={setType}
                  placeholder="Select Type"
                />
              </div>

              <div className="input-field">
                <label htmlFor="type-select">Discipline</label>
                <MultiSelect
                  options={disciplineOptions}
                  value={discipline}
                  onChange={setDiscipline}
                  placeholder="Select Type"
                />
              </div>

              <div className="input-field">
                <label htmlFor="type-select">Status</label>
                <MultiSelect
                  options={statusOptions}
                  value={status}
                  onChange={setStatus}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="field4">Revision</label>
                <input type="text" id="field4" placeholder="Select values..." />
              </div>
            </div>
            <div className="row">
              <div className="input-field">
                <label htmlFor="field1">Construction Work Package(CWP)</label>
                <input type="text" id="field1" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">Equipment Tag</label>
                <MultiSelect
                  options={equipmentTagOptions}
                  value={equipmentTag}
                  onChange={setEquipmentTag}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="field4">Originator</label>
                <input type="text" id="field4" />
              </div>
              <div className="input-field">
                <label htmlFor="field3">Client/3rd Party Document Number</label>
                <input type="text" id="field3" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="field4">VOR Codes & Descriptions</label>
                <input type="text" id="field4" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="field1">
                  Client/3rd Party Document Revision
                </label>
                <input type="text" id="field1" placeholder="Select values..." />
              </div>
            </div>
            <div className="row">
              <div className="input-field">
                <label htmlFor="field2">
                  Vendor or Internal Document Number
                </label>
                <input type="text" id="field2" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="field3">
                  Vendor or Internal Document Revision
                </label>
                <input type="text" id="field3" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="field4">Commissioning System ID</label>
                <input type="text" id="field4" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">Release Purpose</label>
                <MultiSelect
                  options={releasePurposeOptions}
                  value={releasePurpose}
                  onChange={setReleasePurpose}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">Organization Code</label>
                <MultiSelect
                  options={organizationCodeOptions}
                  value={organizationCode}
                  onChange={setOrganizationCode}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">Unit Code</label>
                <MultiSelect
                  options={unitCodeOptions}
                  value={unitCode}
                  onChange={setUnitCode}
                  placeholder="Select Type"
                />
              </div>
            </div>
            <div className="row">
              <div className="input-field">
                <label htmlFor="type-select">Element</label>
                <MultiSelect
                  options={elementOptions}
                  value={element}
                  onChange={setElement}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">Document Class</label>
                <MultiSelect
                  options={documentClassOptions}
                  value={documentClass}
                  onChange={setDocumentClass}
                  placeholder="Select Type"
                />
              </div>
              <div className="input-field">
                <label htmlFor="field4">Review Status</label>
                <input type="text" id="field4" placeholder="Select values..." />
              </div>
              <div className="input-field">
                <label htmlFor="type-select">OT Integration System</label>
                <MultiSelect
                  options={oTIntegrationSystemOptions}
                  value={oTIntegrationSystem}
                  onChange={setOTIntegrationSystem}
                  placeholder="Select Type"
                />
              </div>
            </div>

            {/* <div className="row">
                        <div className="input-field">
                            <label htmlFor="startDate">Date Type</label>
                            <input
                                type="date"
                                id="startDate"
                                value={startDate}
                                onChange={handleStartDateChange}
                            />
                        </div>
                        <div className="input-field">
                            <label htmlFor="endDate">Date Range</label>
                            <input
                                type="date"
                                id="endDate"
                                value={endDate}
                                onChange={handleEndDateChange}
                                min={startDate}
                            />
                        </div>

                    </div> */}

            <div className="row">
              <div className="more-filters">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.854 7.646a.5.5 0 0 0 0-.708L7.207 3.5a.5.5 0 1 0-.707.707L9.293 6H1.5a.5.5 0 0 0 0 1h7.793l-2.793 2.793a.5.5 0 1 0 .707.707l3.646-3.646z" />
                </svg>
                <label htmlFor="startDate">More Filters(0)</label>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom">
          <div className="options">
            <div className="left">
              <button className="arrow-button">
                Transmit
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </span>
              </button>
              <button className="arrow-button">
                Tools
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </span>
              </button>
              <button className="arrow-button">
                Reports
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <div className="right">
              <button
                className="search"
                onClick={() => alert("Add/Remove Columns clicked")}
              >
                Add/Remove Columns
              </button>
            </div>
          </div>
          {/* <div className="labels">
            <label>1 results (0 selected)</label>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault(); 
                handleSelectAll(); 
              }}
            >
              Select All
            </a>
          </div> */}
          <div className="table-wrapper">
            {/* Scrollable Columns */}
            <div className="scrollable-columns">
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    </th>
                    <th>File</th>
                    <th>Document No</th>
                    <th>Revision</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Release Purpose</th>
                    <th>Status</th>
                    <th>Discipline</th>
                    <th>Review Status</th>
                    <th>Revision Date</th>
                    <th>Date Modified</th>
                    <th>Review Source</th>
                    <th>Organization Code</th>
                    <th>Trans...</th>
                    <th>Transmittal In</th>
                    <th>Unit Code</th>
                    <th>Confi...</th>
                    <th>Document Class</th>
                    <th>Size</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>
                        <input
                          type="checkbox"
                          checked={row[0].isSelected}
                          onChange={(e) =>
                            handleRowCheckboxChange(rowIndex, e.target.checked)
                          }
                        />
                      </td>

                      <td style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        <img
                          src="/images/pdf.png"
                          alt="PDF Icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          stroke="#181818"
                          stroke-meterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          viewBox="0 0 16 16"
                        >
                          <path d="M 8.84031 2.40012 L 3.36697 8.19346 C 3.16031 8.41346 2.96031 8.84679 2.92031 9.14679 L 2.67364 11.3068 C 2.58697 12.0868 3.14697 12.6201 3.92031 12.4868 L 6.06697 12.1201 C 6.36697 12.0668 6.78697 11.8468 6.99364 11.6201 L 12.467 5.82679 C 13.4136 4.82679 13.8403 3.68679 12.367 2.29346 C 10.9003 0.913458 9.78697 1.40012 8.84031 2.40012 Z" />
                          <path d="M 7.92651 3.36652 C 8.21318 5.20652 9.70651 6.61318 11.5598 6.79985" />
                          <path d="M 2 14.6667 H 14" />
                        </svg>
                      </td>
                      <td
                        style={{
                          maxWidth: "200px",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          overflow: "hidden",
                        }}
                      >
                        PM210012.11G531.FR2.03304
                      </td>
                      <td style={{ borderLeft: "1px solid #ccc" }}>04</td>
                      <td
                        style={{
                          minWidth: "300px",
                        }}
                      >
                        <a
                          href="#"
                          onClick={() => navigate("/document-properties")}
                        >
                          PV-PLANT - GENERAL - PVSYS CALCULATION REPORT AND
                        </a>
                      </td>
                      <td>Report</td>
                      <td>IFR - Issued for Rev...</td>
                      <td>Code 4</td>
                      <td>ELE - Electrical</td>
                      <td>
                        <a href="#">CODE 4 - No Comments</a>
                      </td>
                      <td>22/02/2025</td>
                      <td>22/23/2025</td>
                      <td>
                        <a href="#">WF-017411</a>
                      </td>
                      <td>LTG</td>
                      <td></td>
                      <td>
                        <a href="#">IDOM-WTRAN-006707</a>
                      </td>
                      <td>531 - PV Group 1</td>
                      <td>No</td>
                      <td></td>
                      <td>14.4 MB</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
